import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { IconButton, Typography } from "@mui/material";
import { DeleteRounded, DownloadRounded } from "@mui/icons-material";
import moment from "moment";
import { roundDecimalValueUptoTwo } from "utils/roundDecimalValue";
import { supplierUi } from "../../../shared/supplierUi";

const DisplayTable = ({
	rows,
	onRowClick,
	downloadUrlColumn,
	columns,
	deleteFun,
	disableEdit = false,
	generateFileDownloadUrl,
}) => {
	const cellStyle = {
		borderColor: supplierUi.border,
		fontSize: 15,
		py: 1.25,
		color: supplierUi.textPrimary,
	};
	const headStyle = {
		...cellStyle,
		fontWeight: 600,
		fontSize: 13,
		color: supplierUi.textSecondary,
		bgcolor: "#FAFAFA",
		textTransform: "uppercase",
		letterSpacing: 0.4,
	};

	const handleDownloadClick = async (filePath) => {
		if (typeof generateFileDownloadUrl === "function") {
			const url = await generateFileDownloadUrl(filePath);
			window.open(url, "_blank");
		}
	};

	if (!rows?.[0]) {
		return (
			<Typography variant="body2" sx={{ color: supplierUi.textMuted, py: 2, fontSize: 15 }}>
				No records to display
			</Typography>
		);
	}

	return (
		<TableContainer
			sx={{
				width: "100%",
				maxWidth: "100%",
				borderRadius: supplierUi.radius,
				border: `1px solid ${supplierUi.border}`,
				overflowX: "hidden",
			}}>
			<Table size="small" sx={{ width: "100%", tableLayout: "fixed" }}>
				<TableHead>
					<TableRow>
						{Object.keys(columns).map((key) => (
							<TableCell key={key} sx={headStyle} component="th" scope="col">
								{columns[key].name}
							</TableCell>
						))}
						{downloadUrlColumn && (
							<TableCell component="th" sx={{ ...headStyle, width: 88 }} scope="col">
								Download
							</TableCell>
						)}
						{!disableEdit && (
							<TableCell component="th" sx={{ ...headStyle, width: 72 }} scope="col">
								Delete
							</TableCell>
						)}
					</TableRow>
				</TableHead>
				<TableBody>
					{rows.map((row, index) => (
						<TableRow
							onClick={() => {
								if (typeof onRowClick === "function") onRowClick(row);
							}}
							key={index}
							sx={{
								cursor: typeof onRowClick === "function" ? "pointer" : "default",
								"&:last-child td, &:last-child th": { borderBottom: 0 },
								"&:hover": { bgcolor: typeof onRowClick === "function" ? "#F9FAFB" : "transparent" },
							}}>
							{Object.keys(columns).map((key) => (
								<TableCell
									component="td"
									scope="row"
									key={key}
									sx={{
										...cellStyle,
										whiteSpace: "normal",
										wordBreak: "break-word",
										overflowWrap: "anywhere",
									}}>
									{columns[key].isDate
										? moment(row[key]).format("DD-MM-YYYY")
										: Number(row[key]) === row[key] && row[key] % 1 !== 0
										? roundDecimalValueUptoTwo(row[key])
										: row[key]}
								</TableCell>
							))}
							{downloadUrlColumn &&
								(typeof generateFileDownloadUrl === "function" ? (
									<TableCell component="td" sx={{ ...cellStyle, width: 88 }}>
										<IconButton size="small" onClick={() => handleDownloadClick(row[downloadUrlColumn])}>
											<DownloadRounded fontSize="small" />
										</IconButton>
									</TableCell>
								) : (
									<TableCell component="td" sx={{ ...cellStyle, width: 88 }}>
										<IconButton size="small" component="a" href={row[downloadUrlColumn]} target="_blank" download>
											<DownloadRounded fontSize="small" />
										</IconButton>
									</TableCell>
								))}
							{!disableEdit && (
								<TableCell component="td" sx={{ ...cellStyle, width: 72 }}>
									<IconButton size="small" onClick={() => deleteFun(row)}>
										<DeleteRounded fontSize="small" />
									</IconButton>
								</TableCell>
							)}
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default DisplayTable;
